import { useTranslation } from "react-i18next";
import usePosPaymentHook from "@/shared/hooks/usePosPaymentHook";
import { cn } from "@/shared/utils/cn";
import useCashDroPaymentHook from "@/shared/hooks/useCashDroPaymentHook";
import { PaymentMethodEnum } from "@/shared/utils/enum";

type PaymentItemProps = {
  isDisabled: boolean;
  onClick: () => void;
  className?: string;
  label?: string;
  isSelected?: boolean;
};

const PaymentItem = ({
  isDisabled,
  onClick,
  className,
  label,
  isSelected,
}: PaymentItemProps) => {
  const handleClick = () => {
    if (isDisabled) return;
    onClick();
  };

  return (
    <div
      className={cn(
        "relative w-full rounded-xl py-3 text-center hover:bg-primary/15 text-2xl 2xl:text-3xl",
        isSelected
          ? "border border-primary bg-primary/10"
          : "border border-border",
        isDisabled ? "cursor-not-allowed" : "cursor-pointer",
        className
      )}
      onClick={isDisabled ? undefined : handleClick}
    >
      {label}
    </div>
  );
};

type PosPaymentProps = {
  paymentId: number;
  setPaymentId: (paymentId: number, isCashDroSelected: boolean) => void;
  isDisabled?: boolean;
  isCashDroSelected: boolean;
};

const SplitPaymentLedgerPayments = ({
  paymentId,
  setPaymentId,
  isDisabled = false,
  isCashDroSelected,
}: PosPaymentProps) => {
  const { t } = useTranslation();
  const cashDro = useCashDroPaymentHook();
  const { paymentList } = usePosPaymentHook(true);

  const handlePosPaymentClick = (
    paymentId: number,
    isCashDroSelected: boolean = false
  ) => {
    setPaymentId(paymentId, isCashDroSelected);
  };

  return (
    <div
      className="relative grid grid-cols-2 lg:grid-cols-3 gap-2"
      style={{ fontWeight: 600 }}
    >
      <>
        {cashDro.isActive && (
          <PaymentItem
            key={-1}
            label={t("cashDro.title")}
            isSelected={isCashDroSelected}
            isDisabled={isDisabled}
            onClick={() => {
              handlePosPaymentClick(PaymentMethodEnum.CASH, true);
            }}
          />
        )}

        {paymentList.map((payment, index) => (
          <PaymentItem
            label={t(`posOrders.${payment.translationKey}`)}
            key={index}
            isSelected={payment.value === paymentId && !isCashDroSelected}
            isDisabled={isDisabled}
            onClick={() => handlePosPaymentClick(payment.value, false)}
          />
        ))}
      </>
    </div>
  );
};

export default SplitPaymentLedgerPayments;
